import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LorenHomeComponent } from "./components/loren-home/loren-home.component";
import { LorenAllAssetResolver } from "../loren-assets/resolvers/loren-asset-all.resolver";
import { LorenNotificationsResolver } from "../../shared/resolvers/loren-notifications.resolver.ts/loren-notifications.resolver";

const routes: Routes = [
  {
    path: "",
    resolve: {
      assets: LorenAllAssetResolver,
      notifications: LorenNotificationsResolver,
    },
    component: LorenHomeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LorenHomeRoutingModule {}
